import useOfflineMessage from './useOfflineMessage'

export default useOfflineMessage
